import React, { useState, useEffect, useMemo } from "react";
import DashboardWrapper from "../../components/DashboardWrapper";
import CrudTable from "../../components/dashboard/table/CrudTable";
import productService from "../../services/productService";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

export default function HomeSectionProducts() {
  const [sections, setSections] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
const [searchText, setSearchText] = useState("");
  // ✅ FETCH DATA
const fetchData = async () => {
  try {
    setLoading(true);

    const res = await productService.getAllHomeSections();

    const sectionsArray = Array.isArray(res.data?.data)
      ? res.data.data
      : Array.isArray(res.data)
        ? res.data
        : [];

    console.log("Latest Home Sections:", sectionsArray);

    const updatedSections = sectionsArray.map((item, index) => ({
      ...item,
      sl: index + 1,
      products_count: Array.isArray(item.products)
        ? item.products.length
        : 0,
    }));

    setSections(updatedSections);

    const productRes = await productService.getAllProducts();

    const productsArray = Array.isArray(productRes.data?.data)
      ? productRes.data.data
      : Array.isArray(productRes.data)
        ? productRes.data
        : [];

    setProducts(productsArray);
  } catch (error) {
    console.error("Failed to fetch home sections:", error);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    fetchData();
  }, []);

  // ✅ DELETE
const handleDelete = (id) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#1276a1",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Yes, delete it!",
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        await productService.deleteHomeSection(id);

        // ✅ SUCCESS POPUP (LIKE YOUR IMAGE)
        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Product has been deleted.",
          confirmButtonColor: "#3b82f6",
        });

        fetchData();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: "Failed to delete product.",
        });
      }
    }
  });
};

  // ✅ STATUS TOGGLE
const handleToggleStatus = async (item) => {
  try {
    await productService.updateHomeSection(item.id, {
      name: item.name,
      // sort_order: item.sort_order,
      status: item.status ? 0 : 1,
      products: (item.products || []).map((p) =>
        typeof p === "object" ? p.id : p
      ),
    });

    // ✅ SUCCESS POPUP (same like your image)
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: "Product status updated.",
      confirmButtonColor: "#37a7e3",
    });

    fetchData();
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: "Failed to update status.",
    });
  }
};

  // ✅ TABLE DATA
const tableData = useMemo(() => {
  return sections.map((item, index) => {
    const associatedProducts = Array.isArray(item.products)
      ? item.products
      : [];

    return {
      ...item,
      sl: index + 1,
      products_count: associatedProducts.length,
    };
  });
}, [sections]);

  return (
    <DashboardWrapper>
      <div className="container-fluid mt-4">

        <div className="d-flex justify-content-between align-items-center mb-4"> 
            <button
            className="btn btn-secondary"
            onClick={() => navigate(-1)}
          >
            Back
          </button> 
          <button 
            className="btn btn-primary"
            onClick={() => navigate("/admin/create-home-section")} 
                     style={{
    backgroundColor: "#3b82f6",
    borderColor: "#3b82f6",
    color: "#fff"
  }}
          >
            Create Home Section
          </button>
        </div>

        <div className="card">
              <div className="card-header d-flex flex-wrap justify-content-between align-items-center gap-3">
       <h4 className="mb-0">Home Section Products</h4>

  <input
    type="text"
    className="form-control"
    placeholder="Search products..."
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    style={{
      width: "260px",
      maxWidth: "100%",
      borderRadius: "6px",
    }}
  />
</div>

       {loading ? (
  <div className="d-flex justify-content-center align-items-center p-5">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
) : (
  <div className="card-body">
    <CrudTable
      data={tableData}
      columns={["sl", "name",  "products_count", "status"]}
      onEdit={(item) => {
        navigate(`/admin/edit-home-section/${item.id}`, { state: { section: item } });
      }}
      onDelete={handleDelete}
       searchText={searchText}
      onToggleStatus={handleToggleStatus}
    />
  </div>
)}
        </div>
      </div>
    </DashboardWrapper>
  );
}